//获取对象中的某个属性，如果不存在该属性则返回默认值
const getValue = (obj, key, defaultValue = null) => {
    return Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : defaultValue;
}

//日期对象转时间字符串
const dateToStr = (date, type, sp = '-') => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    switch (type) {
        case 'date'://日期
            return [year, month, day].map(formatTimeNum).join(sp);
        case 'datetime'://日期 时间
            return [year, month, day].map(formatTimeNum).join(sp) + ' ' + [hour, minute, second].map(formatTimeNum).join(':');
        default:
            return null;
    }

}

//时间字符串转时间对象
const strToDate = (str_date) => {
    return new Date(str_date.replace(/-/g, '/'));
}


//格式化时间数字，如果小于10则自动在第一位补0
const formatTimeNum = (num) => {
    if (num < 10) {
        num = '0' + num.toString();
    }
    return num;
}

//格式化数字，每三位加，号
const formatNumToString = (num) => {
    let reg = /(?=(\B)(\d{3})+$)/g;
    num=num.toString();
    return num.replace(reg,',');
}

const emailFormat = (num) => {
    if (num) {
        return num.replace(/^([0-9A-Za-z]{1,4}).+@(.+)$/g, "$1****@$2")
    }
}

const phoneFormat = (num) => {
    if (num) {
        var str = num.replace('+62', '')
        return str.replace(/(\d*)(\d{4})/, '******$2')
    }
}

//生成随机字母，数字组合
function randomWord(randomFlag, min, max) {
    var str = "",
        range = min,
        arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    // 随机产生
    if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min;
    }
    for (var i = 0; i < range; i++) {
        let pos = Math.round(Math.random() * (arr.length - 1));
        str += arr[pos];
    }
    return str;
}


const time_pick2 = () => {
    return [
        dateToStr(new Date(), "date") ,
        dateToStr(new Date(), "date")
    ]
}

export {
    getValue,
    dateToStr,
    strToDate,
    formatTimeNum,
    formatNumToString,
    phoneFormat,
    emailFormat,
    randomWord,
    time_pick2,
}